/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "ZeroPaymentReportService";
const log: any = LoggerModule.getInstance();

export class ZeroPaymentReportService {
  private static instance: ZeroPaymentReportService;
  private criteria: any;

  private constructor(props: any = {}) { }
  public static getInstance(props: any = {}): ZeroPaymentReportService {
    if (!ZeroPaymentReportService.instance) {
      ZeroPaymentReportService.instance = new ZeroPaymentReportService(props);
    }
    return ZeroPaymentReportService.instance;
  }
  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }
  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getZeroPaymentUsers(args?: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    if (args) {
      this.setCriteria(args);
    }
    compProps = await agent?.getZeroPaymentUsers(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async deleteBox(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.deleteBox(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async sendRemainder(args: any) {
    console.log(args);
    const agent = getAgent();
    return agent.sendRemainder(args);
  }
}
